const unauthorizedTarget = new EventTarget();

export function emitUnauthorized(): void {
  unauthorizedTarget.dispatchEvent(new Event("unauthorized"));
}

export function subscribeUnauthorized(listener: () => void): () => void {
  unauthorizedTarget.addEventListener("unauthorized", listener);
  return () => unauthorizedTarget.removeEventListener("unauthorized", listener);
}
